import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { ActivityLogResponse } from "@/types";

export type FetchActivityLogProps = {
  page?: string | null;
  per_page?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  action?: string | null;
  collaborator?: string | null;
};

export async function fetchActivityLog({
  startDate,
  endDate,
  page,
  per_page,
  action,
  collaborator,
}: FetchActivityLogProps): Promise<ActivityLogResponse> {
  const pageParams = `page=${page || 1}&per_page=${per_page}&startDate=${
        startDate || ""
      }&endDate=${endDate || ""}&event=${action || ""}&collaborator=${collaborator || ""}`;
  const response = await httpRequest.get<ActivityLogResponse>(
    `/log/activity?${pageParams}`
  );
  return response.data;
}

export function useFetchActivityLogsQuery(props: FetchActivityLogProps) {
  const itemsQuery = useQuery({
    queryKey: ["activity-log", props],
    queryFn: () => fetchActivityLog(props),
    keepPreviousData: true,
  });

  return {
    ...itemsQuery,
    data: itemsQuery?.data,
  };
}
